import { EapSettingsPeapFormValidationModel } from './eap-settings-form-peap-protocol.model';

export const initialEapPeapFormValidation: EapSettingsPeapFormValidationModel = {
    username: { state: 'valid' },
    password: { state: 'valid' },
    confirmPassword: { state: 'valid' },
};
